/** Validação e mensagens amigáveis para autenticação (Firebase). */

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

export function normalizeEmail(email) {
  return String(email || '').trim().toLowerCase()
}

export function validateLoginForm({ email, password }) {
  const errors = {}
  const normalized = normalizeEmail(email)

  if (!normalized) {
    errors.email = 'Informe seu e-mail.'
  } else if (normalized.length > 254) {
    errors.email = 'E-mail muito longo.'
  } else if (!EMAIL_RE.test(normalized)) {
    errors.email = 'Digite um e-mail válido (ex.: seu@email.com).'
  }

  if (!password) {
    errors.password = 'Informe sua senha.'
  } else if (password.length < 6) {
    errors.password = 'A senha deve ter pelo menos 6 caracteres.'
  }

  return { ok: Object.keys(errors).length === 0, errors, email: normalized }
}

export function validateRegisterEmail(email) {
  const errors = {}
  const normalized = normalizeEmail(email)

  if (!normalized) {
    errors.email = 'Informe seu e-mail.'
  } else if (normalized.length > 254) {
    errors.email = 'E-mail muito longo.'
  } else if (!EMAIL_RE.test(normalized)) {
    errors.email = 'Digite um e-mail válido (ex.: seu@email.com).'
  }

  return { ok: Object.keys(errors).length === 0, errors, email: normalized }
}

export function validateResetPasswordEmail(email) {
  return validateRegisterEmail(email)
}

const FIREBASE_AUTH_MESSAGES = {
  'auth/invalid-email': 'Digite um e-mail válido.',
  'auth/user-disabled': 'Esta conta foi desativada. Entre em contato com o suporte.',
  'auth/user-not-found': 'E-mail ou senha incorretos.',
  'auth/wrong-password': 'E-mail ou senha incorretos.',
  'auth/invalid-credential': 'E-mail ou senha incorretos.',
  'auth/invalid-login-credentials': 'E-mail ou senha incorretos.',
  'auth/email-already-in-use': 'Este e-mail já está cadastrado. Tente entrar ou recuperar a senha.',
  'auth/weak-password': 'Senha fraca. Use pelo menos 6 caracteres.',
  'auth/too-many-requests': 'Muitas tentativas. Aguarde alguns minutos e tente novamente.',
  'auth/network-request-failed': 'Sem conexão com a internet. Verifique sua rede e tente de novo.',
  'auth/operation-not-allowed': 'Login por e-mail não está disponível no momento.',
  'auth/missing-email': 'Informe seu e-mail.',
  'auth/missing-password': 'Informe sua senha.',
  'auth/popup-closed-by-user': 'Login com Google cancelado.',
  'auth/popup-blocked': 'O navegador bloqueou a janela do Google. Permita pop-ups e tente novamente.',
  'auth/cancelled-popup-request': 'Login com Google cancelado.',
  'auth/account-exists-with-different-credential': 'Este e-mail já está vinculado a outro método de login.',
}

export function getAuthErrorMessage(error) {
  const code = error?.code || ''

  if (FIREBASE_AUTH_MESSAGES[code]) {
    return FIREBASE_AUTH_MESSAGES[code]
  }

  if (code.startsWith('auth/')) {
    return 'Não foi possível completar a operação. Verifique seus dados e tente novamente.'
  }

  const msg = String(error?.message || '').toLowerCase()
  if (msg.includes('network') || msg.includes('fetch')) {
    return 'Sem conexão com a internet. Verifique sua rede e tente de novo.'
  }

  return 'Não foi possível completar a operação. Tente novamente.'
}

/** Mapeia erro do Firebase para campo específico quando fizer sentido. */
export function getAuthFieldErrors(error) {
  const code = error?.code || ''
  if (['auth/invalid-email', 'auth/missing-email'].includes(code)) {
    return { email: FIREBASE_AUTH_MESSAGES[code] }
  }
  if (['auth/wrong-password', 'auth/missing-password', 'auth/invalid-credential', 'auth/invalid-login-credentials', 'auth/user-not-found'].includes(code)) {
    return { password: 'E-mail ou senha incorretos.' }
  }
  return {}
}
